import React from "react";
import { useSelector } from "react-redux";
import { BodyField, CheckTerm } from "../field-input";

const FormContactAuth = ({
  register,
  handleSubmit,
  onSubmit,
  onError,
  errors,
  info,
}) => {
  const { userDisplay: user } = useSelector((state) => state.user);
  const { cms, isInLine } = useSelector((state) => state.contact);

  return (
    <form className="px-3 px-lg-0" onSubmit={handleSubmit(onSubmit, onError)}>
      {
        !isInLine &&
          <div>
            <input type="hidden" name={"type"} value={1} {...register("type")} />
            <div className="border-form-hidden border-color-black border-radius-5">
              <div className="p-15">
                <div className="form-group mt-4 mt-md-0 my-2">
                  <label className="spacing-none">{user && user?.name}さん</label>
                </div>
                <div className="form-group">
                  <label className="mb-2">
                    お問い合わせ内容<span>[必須]</span>
                  </label>
                  <div className="row">
                    <div className="col-12">
                      <BodyField info={info} register={register} errors={errors} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-0 p-15 pb-4">
                <div className="confirm-form auth mt-4">
                  <div className="header bg-confirm-request">
                    <div className="title fs-16 mt-2 mt-md-0">個人情報の取扱い</div>
                    <div className="sub-title sp-0">
                      ▼最後までスクロールしてください
                    </div>
                  </div>
                  <div
                    className="html-design-table form-scroll border-bottom p-3"
                    dangerouslySetInnerHTML={{ __html: cms?.terms1 }}
                  ></div>

                  <CheckTerm register={register} errors={errors} info={info} />
                </div>
              </div>
            </div>
            {/* <!-- GROUP BUTTON --> */}
            <div className="group-btn-custom my-4 my-md-5">
              <div onClick={() => history.go(-1)} className="btn-custom after">
                キャンセル
              </div>
              <input
                type="submit"
                value="入力内容を確認する"
                className="btn-custom red-light before"
              />
            </div>
          </div>
      }
    </form>
  );
};

export default FormContactAuth;
